module.exports = __webpack_public_path__ + "static/media/Mcd.374988aa.gif";